import { render } from "./TosComp.vue?vue&type=template&id=ea00c508&scoped=true&ts=true"
import script from "./TosComp.vue?vue&type=script&lang=ts"
export * from "./TosComp.vue?vue&type=script&lang=ts"

import "./TosComp.vue?vue&type=style&index=0&id=ea00c508&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea00c508"]])

export default __exports__